export default __webpack_public_path__ + "static/media/009.c02efb5b.jpg";